import React from 'react';
import { useFormikContext } from 'formik';
import { Button, Stack, Flex, Spinner } from '@tonic-ui/react';

type SubmitButtonProps = {
  label: string;
  id: string;
  disabled?: boolean;
  width?: string;
  height?: string;
  isLoading?: boolean;
  variant?: string;
} & StyledSystemProps;

const SubmitButton = ({
  label,
  id,
  variant,
  isLoading,
  disabled,
  width = '',
  height = '',
  ...props
}: SubmitButtonProps): JSX.Element => {
  const { isSubmitting } = useFormikContext();
  return (
    <Stack display="inline-flex" position="relative" width={width} height={height}>
      {isLoading && (
        <Flex
          justifyContent="center"
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
        >
          <Spinner />
        </Flex>
      )}

      <Button
        variant={variant ? variant : 'primary'}
        data-id={id}
        type="submit"
        disabled={isLoading ? false : isSubmitting || disabled}
        visibility={isLoading ? 'hidden' : 'visible'}
        width="100%"
        height={height}
        {...props}
      >
        {label}
      </Button>
    </Stack>
  );
};

SubmitButton.displayName = 'SubmitButton';

export default SubmitButton;
